import localizationStrings from "../statics/localization";

export const prettyTimeFormatter = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours === 0 && minutes === 0) {
    return `${seconds} ${localizationStrings.secondShort}`;
  } else if (hours === 0) {
    return `${minutes} ${localizationStrings.shortMinutes} ${seconds} ${localizationStrings.secondShort}`;
  } else if (minutes === 0 && seconds === 0) {
    return `${hours} ${localizationStrings.shortHour}`;
  } else if (minutes === 0) {
    return `${hours} ${localizationStrings.shortHour} ${seconds} ${localizationStrings.secondShort}`;
  } else if (seconds === 0) {
    return `${hours} ${localizationStrings.shortHour} ${minutes} ${localizationStrings.shortMinutes}`;
  } else {
    return `${hours} ${localizationStrings.shortHour} ${minutes} ${localizationStrings.shortMinutes} ${seconds} ${localizationStrings.shortSeconds}`;
  }
};
